import { OptionChat, OptionVideo } from '@@types/telemed';
import { createSlice } from '@reduxjs/toolkit';
import { IAgoraRTCClient } from 'agora-rtc-sdk-ng';

const initialState = {
  loading: {} as any,
  lang: '',
  widen: false,
  mic: true,
  camera: true,
  option_video: {} as OptionVideo,
  option_chat: {} as OptionChat,
  client_agora: {} as IAgoraRTCClient,
};

const telemedSlice = createSlice({
  name: 'telemed',
  initialState,
  reducers: {
    setWiden: (state) => {
      state.widen = !state.widen;
    },
    setMic: (state) => {
      state.mic = !state.mic;
    },
    setCamera: (state) => {
      state.camera = !state.camera;
    },

    setOptionVideo: (state, { payload: { data } }) => {
      state.option_video = data;
    },
    setOptionChat: (state, { payload: { data } }) => {
      state.option_chat = data;
    },
    setClient: (state, { payload: { data } }) => {
      state.client_agora = data;
    },
  },
});

export default telemedSlice;
